import React, { useEffect } from 'react';
import MainView from './main';
import { SnackbarProvider } from 'notistack';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate
} from "react-router-dom";
import { AuthenticationPage, AuthProvider } from './main/auth';
import { WyesThemeProvider } from './theme';

function WrapperAuthenticationPage() {

  const navigate = useNavigate();

  return (
    <AuthenticationPage
      redirectMethod={(path) => navigate(path, { replace: true })}
      onError={() => navigate('/', { replace: true })} />
  )
}

function App() {

  useEffect(() => {
    if (import.meta.env.MODE === 'development') {
      console.warn('RUNNING IN DEVELOPEMENT ENVIRONMENT');
    }
  }, []);

  return (
    <BrowserRouter>
      <WyesThemeProvider>
        <SnackbarProvider maxSnack={3}>
          <AuthProvider
            clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
            cacheLocation={import.meta.env.VITE_AUTH0_CACHE_LOCATION}
            domain={import.meta.env.VITE_AUTH0_DOMAIN}
          >
            <Routes>
              <Route path='/auth/*' element={<WrapperAuthenticationPage />} />
              <Route path='/main/*' element={<MainView />} />
              <Route path="*" element={<Navigate to='/main' replace />} />
            </Routes>
          </AuthProvider>
        </SnackbarProvider>
      </WyesThemeProvider>
    </BrowserRouter>
  );
}

export default App;
